// axios-public.ts
import axios from 'axios';

const axiosPublic = axios.create();

axiosPublic.interceptors.request.use(config => {
  if (config.headers) {
    delete config.headers.Authorization;
    delete config.headers.authorization;
  }

  return config;
});

export default axiosPublic;